import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/antd'
import 'ant-design-vue/dist/antd.css'
import './assets/theme.css'
import './assets/erp-ui.css'
import './assets/list-page-v2.css'
import { initTipFloat } from './utils/tipFloat'
import { hasPerm } from './utils/permission'
import XpTable from './components/XpTable.vue'

Vue.config.productionTip = false
Vue.prototype.$hasPerm = hasPerm
Vue.component('XpTable', XpTable)

initTipFloat()

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
